import ProductSupport from '@elem/compCommon/ProductConstructor/Support';

export default function TabSupport({ supportData, theme, spuId }: { supportData: any; theme: any; spuId: any }) {
    return (
        <>
            <ProductSupport supportData={supportData} theme={theme} spuId={spuId} />
        </>
    );
}
